export const DEPARTMENTS = [
  'Technology',
  'Product',
  'QA',
  'HR',
  'Finance',
  'IT',
  'Marketing',
  'Management'
];
